var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMissingStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4319_6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 27,
    rx: 25.5,
    ry: 26,
    fill: "#F3F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5 20.8189C28.5 22.3622 27.8854 23.8423 26.7915 24.9336C25.6975 26.0248 24.2138 26.6379 22.6667 26.6379C21.1196 26.6379 19.6358 26.0248 18.5419 24.9336C17.4479 23.8423 16.8333 22.3622 16.8333 20.8189C16.8333 19.2757 17.4479 17.7956 18.5419 16.7043C19.6358 15.6131 21.1196 15 22.6667 15C24.2138 15 25.6975 15.6131 26.7915 16.7043C27.8854 17.7956 28.5 19.2757 28.5 20.8189ZM34.3333 35.3663V38.2758H11V35.3663C11 32.1513 16.2208 29.5474 22.6667 29.5474C29.1125 29.5474 34.3333 32.1513 34.3333 35.3663ZM39.4375 30.2747V32.4568H37.25V30.2747H39.4375ZM36.5208 23.0011H34.3333V22.2737C34.3333 21.1162 34.7943 20.0062 35.6147 19.1877C36.4352 18.3693 37.548 17.9095 38.7083 17.9095C39.8687 17.9095 40.9815 18.3693 41.8019 19.1877C42.6224 20.0062 43.0833 21.1162 43.0833 22.2737C43.0833 23.6848 42.3542 25.0086 41.2021 25.7796L40.7646 26.056C39.9333 26.6379 39.4375 27.5253 39.4375 28.529V28.82H37.25V28.529C37.25 26.7979 38.125 25.1832 39.5687 24.2376L39.9917 23.9612C40.5604 23.5829 40.8958 22.9574 40.8958 22.2737C40.8958 21.695 40.6654 21.1399 40.2551 20.7307C39.8449 20.3215 39.2885 20.0916 38.7083 20.0916C38.1282 20.0916 37.5718 20.3215 37.1615 20.7307C36.7513 21.1399 36.5208 21.695 36.5208 22.2737V23.0011Z",
    fill: "#4297FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4319_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingStatusIcon);
export default __webpack_public_path__ + "static/media/missingStatusIcon.fce16b53f7cb5ffe4324c58ad48bd3b2.svg";
export { ForwardRef as ReactComponent };